import type { WebchatTranslations } from '.'

export const de: WebchatTranslations = {
  'composer.placeholder': 'Nachricht eingeben...',
  'composer.sendButton.ariaLabel': 'Schaltfläche Nachricht senden',
  'composer.voiceButton.ariaLabel': 'Schaltfläche Spracheingabe',
  'composer.fileButton.ariaLabel': 'Schaltfläche Datei hochladen',
  'composer.messageInput.ariaLabel': 'Nachrichteneingabe',

  'fileAttachment.uploadError': 'Fehler beim Hochladen',
  'fileAttachment.fallbackExtension': 'Datei',
  'fileAttachment.removeButton.ariaLabel': 'Schaltfläche Datei entfernen',

  'header.defaultBotName': 'Bot',
  'header.expandButton.ariaLabel': 'Schaltfläche Kopfzeile erweitern',
  'header.sound.enable': 'Chat-Töne aktivieren',
  'header.sound.disable': 'Chat-Töne deaktivieren',

  'conversationHistory.title': 'Unterhaltungen',
  'conversationHistory.empty': 'Noch keine Unterhaltung begonnen',
  'conversationHistory.newConversation': 'Neue Unterhaltung',
  'conversationHistory.sentAttachment': 'Anhang gesendet',
  'conversationHistory.showButton.ariaLabel': 'Schaltfläche Letzte Unterhaltungen anzeigen',

  'restartConversation.title': 'Neue Unterhaltung erstellen',
  'restartConversation.description': 'Dies löscht die aktuelle Unterhaltung und startet eine neue.',
  'restartConversation.confirm': 'Neue Unterhaltung',
  'restartConversation.cancel': 'Abbrechen',
  'restartConversation.button.ariaLabel': 'Schaltfläche Unterhaltung neu starten',

  'closeButton.ariaLabel': 'Schaltfläche Chatbot schließen',

  'feedback.title': 'Helfen Sie uns, besser zu werden',
  'feedback.description': 'Bitte geben Sie uns Feedback, damit wir uns verbessern können.',
  'feedback.confirm': 'Feedback senden',
  'feedback.cancel': 'Abbrechen',
  'feedback.placeholder': 'Sagen Sie uns, was schiefgelaufen ist...',

  'error.configuration': 'Konfigurationsfehler',
  'error.bot': 'Bot-Fehler',
  'error.network': 'Netzwerkfehler',
  'error.disconnected': 'Getrennt',
  'error.unexpected': 'Unerwarteter Fehler',

  'dropdown.placeholder': 'Auswählen...',

  'message.status.delivered': 'Zugestellt',

  'date.today': 'Heute',
  'date.yesterday': 'Gestern',
}
